module.exports = __webpack_public_path__ + "static/img/TrebuchetMS-Bold.01640bd.svg";